import { BalanceType, BalanceTypeTitles } from '@/entities/balances'

/**
 * Утилита для парсинга комментариев и замены типов балансов на их названия
 * @param comment - строка комментария с типами балансов в квадратных скобках
 * @returns строка с замененными типами балансов на их тайтлы в кавычках
 *
 * @example
 * parseBalanceComment('Списание с баланса [User] при переводе на баланс [Deposit]')
 * // => 'Списание с баланса "Пользовательский баланс" при переводе на баланс "Депозитный баланс"'
 */
export const parseBalanceComment = (comment: string): string => {
  if (!comment) return comment

  const balanceTypeRegex = /\[(\w+)\]/g

  return comment.replace(balanceTypeRegex, (match, balanceTypeKey) => {
    const balanceTypeValue = BalanceType[balanceTypeKey as keyof typeof BalanceType]

    if (balanceTypeValue !== undefined) {
      const title = BalanceTypeTitles[balanceTypeValue]
      return `"${title}"`
    }

    return match
  })
}
